import React, { useEffect } from "react";
import CouponCarroussel from "./couponCarroussel";
import CouponComponent from "./couponComponent";
import StyledDiv from "./index.styles";
import { useParams } from "react-router-dom";

const CouponPage: React.FC = () => {
  const { couponId } = useParams();
  
  return (
    <StyledDiv>
      <h3 className="header">
        A sua equipe de saúde <span className="coupon-header-bold">acessível</span> e{" "}
        <span className="header-bold">sem burocracia</span>
      </h3>
      <div className="carroussel">
        <CouponCarroussel />
      </div>
      <div className="component">
        <CouponComponent couponId={couponId} />
      </div>
    </StyledDiv>
  );
};

export default CouponPage;
